import { render, staticRenderFns } from "./VuetifyResource.vue?vue&type=template&id=377e61b2"
import script from "./VuetifyResource.vue?vue&type=script&lang=js"
export * from "./VuetifyResource.vue?vue&type=script&lang=js"
import style0 from "./VuetifyResource.vue?vue&type=style&index=0&id=377e61b2&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports